import React, { useState } from 'react';

export interface Props {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  group?: boolean;
}

function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

// A stable hue per name, so a sender with no picture still has "their"
// colour everywhere they appear.
function hueFor(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) % 360;
  }
  return hash;
}

const Avatar: React.FC<Props> = ({ name, src, size = 'md', group = false }) => {
  const [broken, setBroken] = useState(false);
  const showImage = src && !broken;
  return (
    <span
      className={`Phone_avatar Phone_avatar-${size}`}
      style={
        showImage
          ? undefined
          : ({ '--ph-avatar-hue': hueFor(name) } as React.CSSProperties)
      }
      aria-hidden="true"
    >
      {showImage ? (
        <img src={src} alt="" onError={() => setBroken(true)} />
      ) : group ? (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7.5 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2 19.2C2 15.9 5 13.5 9 13.5s7 2.4 7 5.7V20H2v-.8Zm15.3.8v-.8c0-1.7-.6-3.2-1.6-4.4.3 0 .5-.1.8-.1 3.1 0 5.5 1.9 5.5 4.5V20h-4.7Z" />
        </svg>
      ) : (
        <span className="Phone_avatarInitials">{initials(name)}</span>
      )}
    </span>
  );
};

export default Avatar;
